import 'intersection-observer'
import React, { useState, useRef, useEffect, useContext } from 'react'
import styled, { css } from 'styled-components/macro'
import estyled from '@emotion/styled'
import { Link } from '@reach/router'
import Observer from '@researchgate/react-intersection-observer'
import ReactGA from 'react-ga'
import { GelScreenDetectorContext } from '@tal-gel/components'
import {
  GelHeading1,
  GelHeading4,
  GelParagraph,
  GelButton,
  GelList,
  GelListItem
} from '@tal-gel/components'
import { getGelTokens } from '@tal-gel/theming'

import Logo from '../../components/Logo/Logo'
// import Caption from '../../components/Typography/Caption'
import Collapse from '../../components/Collapse/Collapse'
// import check from './check.svg'
import {
  Header,
  HeaderWrapper,
  ButtonWrapper,
  Hero,
  Content,
  EmailSection
} from '../Shared/Components'
// import arrow from './arrow-bot.svg'
import Footer from '../../components/Footer/Footer'
import EmailForm from './GEL/EmailForm'
import image from './recommendations-image.png'

// TODO clean and remove

const Wrapper = styled.div`
  position: relative;
  /* floating email */
  /* padding-bottom: ${(props) =>
    props.emailVisible && !props.confirmation ? '0' : '56px'};

  @media only screen and (min-width: 900px) {
    padding-bottom: ${(props) => (props.emailVisible ? '0' : '114px')};
  }

  @media only screen and (min-width: 1500px) {
    padding-bottom: ${(props) => (props.emailVisible ? '0' : '82px')};
  } */
`

const Collapses = styled.div`
  margin-bottom: 24px;

  @media only screen and (min-width: 768px) {
    margin-bottom: 64px;
    width: 100%;
    max-width: 1032px;
  }

  & > div:not(:last-of-type) {
    margin-bottom: 24px;
  }
`

const TextWrapper = styled.div`
  @media only screen and (min-width: 768px) {
    max-width: 680px;
  }
`

const GeneralHealth = styled.div`
  background-color: ${() => getGelTokens().brand.brandColorGrayT05};
  padding: 80px 20px;

  @media only screen and (min-width: 768px) {
    display: flex;
    justify-content: center;
    padding: 100px;
  }
`

const Redirect = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.theme.colors.brand.primary};
`

const StyledLink = styled(Link)`
  font-family: 'Pluto Sans', sans-serif;
  font-size: 28px;
  line-height: 72px;
  font-weight: ${(props) => (props.bold ? 'bold' : 'normal')};
  color: ${(props) => props.theme.colors.grey.white};
  text-decoration: none;

  &:hover {
    cursor: pointer;
    filter: brightness(80%);
  }

  &:focus,
  &:visited,
  &:active {
    text-decoration: none;
  }
`

const InnerContent = styled.div`
  background-color: #fff;
  padding: 80px 20px;

  @media only screen and (min-width: 768px) {
    padding: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`

// const FloatingEmailMobile = styled.div`
//   position: fixed;
//   bottom: 0;
//   width: 100%;
//   background-color: ${(props) => props.theme.colors.grey.white};
//   padding: 8px 16px;
//   display: flex;
//   align-items: center;
//   justify-content: space-between;

//   @media only screen and (min-width: 900px) {
//     display: none;
//   }
// `

// const MobileButtonWrapper = styled.div`
//   display: flex;
//   justify-content: center;
//   margin-left: 8px;
//   min-width: 112px;
// `

// const FloatingEmailDesktop = styled.div`
//   display: none;
//   position: fixed;
//   bottom: 0;
//   width: 100%;
//   background-color: ${(props) => props.theme.colors.grey.white};

//   padding: 8px 16px;

//   @media only screen and (min-width: 900px) {
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     padding: 16px 32px;
//   }
// `

// const FloatingInnerWrapper = styled.div`
//   width: 100%;
//   display: ${(props) => (props.confirmation ? 'flex' : 'block')};

//   @media only screen and (min-width: 1500px) {
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//     max-width: 1440px;
//   }
// `

// const FloatingTextWrapper = styled.div`
//   display: none;

//   @media only screen and (min-width: 900px) {
//     display: inherit;
//     margin-bottom: 8px;
//   }

//   @media only screen and (min-width: 1500px) {
//     min-width: 536px;
//     margin-right: 96px;
//   }
// `

// const ConfirmationWrapper = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   width: 100%;

//   @media only screen and (min-width: 1500px) {
//     max-width: 1440px;
//   }
// `

// const ConfirmationTextWrapper = styled.div`
//   width: 536px;
// `

// const StickyForm = styled.div`
//   display: flex;
//   min-width: 750px;
// `

// const HideOnDesktop = styled.div`
//   @media only screen and (min-width: 768px) {
//     display: none;
//   }
// `

// const Names = styled.div`
//   & > div {
//     margin-bottom: 16px;
//   }

//   @media only screen and (min-width: 768px) {
//     display: flex;
//     & > div:not(:last-of-type) {
//       margin-right: 24px;
//     }
//   }
// `

const ConfirmSuccess = styled.div`
  ${(props) =>
    props.confirmation &&
    css`
      /* background-color: ${(props) => props.theme.colors.brand.tal}; */
      border: 2px solid ${(props) => props.theme.colors.brand.talBorder};
      border-radius: 4px;
      padding: 10px;

      & > h4,
      & > p {
        color: #fff;
      }
    `}

  @media only screen and (min-width: 768px) {
    max-width: 680px;

    ${(props) =>
      props.confirmation &&
      css`
        padding: 32px 88px;
        max-width: 856px;
      `}
  }
`

const ImageSection = styled.div`
  display: flex;
  justify-content: center;
`

const ImageSectionInnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding: 80px 20px;

  @media only screen and (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 100px;
    max-width: 1440px;
  }
`

const ImageWrapper = styled.div`
  display: flex;
  max-width: 387px;
  margin-bottom: 40px;
  @media only screen and (min-width: 768px) {
    order: 2;
  }
`

const Image = styled.img`
  width: 100%;
`

const ImageText = styled.div`
  @media only screen and (min-width: 768px) {
    max-width: 650px;
    width: 100%;
    margin-right: 3rem;
  }
`

const ListWrapper = estyled.div`
  margin: 20px 0;

  & > ul > li > span {
    font-size: 20px;
    font-family: 'Pluto Sans', sans-serif;
  }
`

const Recommendations = ({ location, voucher, demo }) => {
  const { screen, isLargerThanSmScreen } = useContext(GelScreenDetectorContext)
  const [emailVisible, setEmailVisible] = useState(false)
  const [confirmation, setConfirmation] = useState(false)

  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search)
  }, [])

  const handleIntersection = (e) => {
    const { isIntersecting } = e

    if (emailVisible !== isIntersecting) {
      setEmailVisible(isIntersecting)
    }
  }

  const emailSectionRef = useRef(null)

  const scrollToEmail = () => {
    if (emailSectionRef && emailSectionRef.current) {
      emailSectionRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
    }
  }

  const getConfirmationText = () => {
    let header = ''
    let body = ''

    if (confirmation) {
      if (voucher) {
        if (location.state.responseData.phaseTwoEligible) {
          header =
            'Confirmation. You will be receiving your $10 voucher by email as well as reminders to do your screeners & enter the main reward draw.'
          body =
            'Look out for these reminders so you can enter before the closing date of xx/xx/20'
        } else {
          header =
            'Confirmation. You will be receiving your $10 voucher by email.'
        }
      } else {
        header =
          'Confirmation. You will be receiving emails that remind you to take the recommendations you’ve been given above.'
      }
    } else {
      if (voucher) {
        header = 'Your reward'
        body =
          'To say thank you for taking proactive health steps/ completing the TAL Health Scout quiz we’re going to send you a $10 Gift card that can be used at selected Australian retailers. Simply fill out the form below.'
      } else {
        header = 'Your recommendation reminders'
        body =
          'Enter your details to receive recommendation reminders by email.'
      }
    }

    return [header, body]
  }

  const handleConfirmation = () => {
    setConfirmation(true)
  }

  if (
    location.state &&
    location.state.responseData &&
    location.state.responseData.recommendations
  ) {
    return (
      <Wrapper emailVisible={emailVisible} confirmation={confirmation}>
        <Header>
          <HeaderWrapper>
            <Logo
              version='full'
              height={isLargerThanSmScreen(screen) ? '37px' : '22px'}
            />
            <ButtonWrapper>
              <GelButton
                primary
                medium
                iconRight='Email'
                onClick={scrollToEmail}
              >
                {voucher ? 'Redeem' : 'Submit'}
              </GelButton>
              {!demo && isLargerThanSmScreen(screen) && (
                <Logo version='cbus' ml={8} />
              )}
            </ButtonWrapper>
          </HeaderWrapper>
        </Header>
        <Hero demo={demo}>
          <GelHeading1
            inverse
            textAlign='center'
            marginBottom={8}
            style={{ maxWidth: '450px' }}
          >
            Thanks for taking five for your health
          </GelHeading1>
          <GelParagraph
            large
            inverse
            textAlign='center'
            marginBottom={32}
            style={{ fontWeight: 400, lineHeight: '20px', maxWidth: '850px' }}
          >
            Here are your health check recommendations. Find out how they can
            help and then take the next step for your health by having a check.
          </GelParagraph>
        </Hero>
        <ImageSection>
          <ImageSectionInnerWrapper>
            <ImageWrapper>
              <Image src={image} alt='TAL' />
            </ImageWrapper>
            <ImageText>
              <GelHeading4
                style={{ color: getGelTokens().brand.brandColorGray }}
              >
                The recommendations provided are related to current preventative
                activities for adults for the following areas:
              </GelHeading4>
              <ListWrapper>
                <GelList iconSize='large'>
                  <GelListItem>Colorectal (Bowel) Cancer</GelListItem>
                  <GelListItem>Breast Cancer</GelListItem>
                  <GelListItem>Skin Cancer</GelListItem>
                  <GelListItem>
                    Cardiovascular (heart and blood vessel) health
                  </GelListItem>
                </GelList>
              </ListWrapper>
              <GelParagraph
                large
                style={{
                  fontWeight: '400',
                  fontSize: '18px',
                  fontFamily: 'Pluto Sans Condensed',
                  color: getGelTokens().brand.brandColorGrayT40,
                  lineHeight: '20px'
                }}
              >
                Each of the recommendations is aligned with the current
                guidelines of The Royal Australian College of General
                Practitioners (RACGP), as well as the BreastScreen Australia
                program and National Bowel Cancer Screening Program
              </GelParagraph>
            </ImageText>
          </ImageSectionInnerWrapper>
        </ImageSection>
        <Content>
          <Collapses>
            {Object.entries(location.state.responseData.recommendations).map(
              (item, index) => (
                <Collapse
                  key={item[1].title}
                  data={item[1]}
                  index={index + 1}
                />
              )
            )}
          </Collapses>
        </Content>
        <InnerContent>
          <Observer onChange={handleIntersection}>
            <EmailSection ref={emailSectionRef}>
              <ConfirmSuccess confirmation={confirmation}>
                <GelHeading4
                  textAlign='center'
                  marginBottom={12}
                  style={{ color: getGelTokens().brand.brandColorPrimary1 }}
                >
                  {getConfirmationText()[0]}
                </GelHeading4>
                <GelParagraph
                  large
                  textAlign='center'
                  marginBottom={32}
                  style={{
                    fontWeight: '400',
                    fontSize: '18px',
                    fontFamily: 'Pluto Sans Condensed',
                    color: getGelTokens().brand.brandColorGrayT50,
                    lineHeight: '20px'
                  }}
                >
                  {getConfirmationText()[1]}
                </GelParagraph>
                {!confirmation && (
                  <EmailForm
                    id={location.state.responseData}
                    onConfirmation={handleConfirmation}
                    voucher={voucher}
                  />
                )}
              </ConfirmSuccess>
            </EmailSection>
          </Observer>
          {location.state.responseData.phaseTwoEligible && (
            <TextWrapper>
              <GelHeading4
                textAlign='center'
                marginBottom={12}
                style={{ color: getGelTokens().brand.brandColorPrimary1 }}
              >
                Win big for your super
              </GelHeading4>
              <GelParagraph
                large
                textAlign='center'
                style={{
                  fontWeight: '400',
                  fontSize: '18px',
                  fontFamily: 'Pluto Sans Condensed',
                  color: getGelTokens().brand.brandColorGrayT50,
                  lineHeight: '20px'
                }}
              >
                If you decide to have one of your recommended health checks,
                you’ll have the chance to win a $5,000 contribution to your
                super. Just let us know which check you had (we don’t need any
                results) and we’ll put you in the draw: it’s that easy. Fill out
                the form above to receive all the info about where to enter.
              </GelParagraph>
            </TextWrapper>
          )}
        </InnerContent>
        <GeneralHealth>
          <TextWrapper>
            <GelHeading4
              textAlign='center'
              marginBottom={12}
              style={{ color: getGelTokens().brand.brandColorPrimary1 }}
            >
              Keep up the good work
            </GelHeading4>
            <GelParagraph
              large
              textAlign='center'
              style={{
                fontWeight: '400',
                fontSize: '18px',
                fontFamily: 'Pluto Sans Condensed',
                color: getGelTokens().brand.brandColorGrayT50,
                lineHeight: '20px'
              }}
            >
              We want all our members to have a rewarding and secure retirement,
              which goes beyond your financial wellbeing. Physical and mental
              health play a huge part, which is why preventative health care is
              so important. <br /> <br />
              Keep up the good work and chat to your GP about other steps you
              can take to make your retirement a happier and healthier one.
            </GelParagraph>
          </TextWrapper>
        </GeneralHealth>
        <Footer demo={demo} />
        {/* {!emailVisible && (
          <>
            {!confirmation && (
              <FloatingEmailMobile>
                <Caption primary bold>
                  {voucher
                    ? 'Enter your name and email address to receive your gift card'
                    : 'Enter your name and email address to receive recommendation reminders'}
                </Caption>
                <MobileButtonWrapper>
                  <Button
                    onClick={scrollToEmail}
                    title={voucher ? 'Redeem' : 'Submit'}
                    type='primary'
                    icon={arrow}
                    smallIcon
                    showOnMobile
                    caption
                  />
                </MobileButtonWrapper>
              </FloatingEmailMobile>
            )}
            <FloatingEmailDesktop>
              {confirmation ? (
                <ConfirmationWrapper>
                  <ConfirmationTextWrapper>
                    <Body secondary bold>
                      {getConfirmationText()[0]}
                    </Body>
                  </ConfirmationTextWrapper>
                  <Button
                    title='Submitted!'
                    type='confirmation'
                    icon={check}
                    showOnMobile
                  />
                </ConfirmationWrapper>
              ) : (
                <FloatingInnerWrapper>
                  <FloatingTextWrapper>
                    <Body primary bold>
                      {voucher
                        ? 'Enter your name and email address to receive your gift card'
                        : 'Enter your name and email address to receive recommendation reminders'}
                    </Body>
                  </FloatingTextWrapper>
                  <StickyForm>
                    <RegularOutside
                      mr={1}
                      noMinWidth
                      placeholder='First Name'
                      noButton
                      value={firstName}
                      setValue={setFirstName}
                      error={firstNameError}
                      setError={setFirstNameError}
                    />
                    <RegularOutside
                      mr={1}
                      noMinWidth
                      placeholder='Last Name'
                      noButton
                      value={lastName}
                      setValue={setLastName}
                      error={lastNameError}
                      setError={setLastNameError}
                    />
                    <RegularOutside
                      mr={1}
                      noMinWidth
                      placeholder='Email'
                      noButton
                      value={email}
                      setValue={setEmail}
                      error={emailError}
                      setError={setEmailError}
                    />
                    <Button
                      error={
                        firstNameError || lastNameError || emailError ? 1 : 0
                      }
                      title={voucher ? 'Redeem' : 'Submit'}
                      onClick={handleSubmit}
                      icon={voucher ? gift : envelope}
                      showOnMobile
                    />
                  </StickyForm>
                </FloatingInnerWrapper>
              )}
            </FloatingEmailDesktop>
          </>
        )} */}
      </Wrapper>
    )
  } else {
    return (
      <Wrapper>
        <Redirect>
          <StyledLink to='/survey'>
            Finish <code>/survey</code>
          </StyledLink>
        </Redirect>
      </Wrapper>
    )
  }
}

export default Recommendations
